import { useState } from "react";

export const Linha = ({ label, value }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "220px 1fr",
      gap: 12,
      padding: "6px 0",
      borderBottom: "1px solid #f0f0f0",
    }}
  >
    <div style={{ fontWeight: 600, color: "#666" }}>{label}</div>
    <div style={{ color: "#333" }}>{value}</div>
  </div>
);

export const Bloco = ({ titulo, children, defaultCollapsed = true }) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div
      style={{
        background: "#fafafa",
        borderRadius: 12,
        padding: "12px 16px",
        marginBottom: 16,
        boxShadow: "inset 0 0 4px rgba(0,0,0,0.05)",
      }}
    >
      <button
        type="button"
        onClick={() => setCollapsed((prev) => !prev)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          background: "transparent",
          border: "none",
          padding: 0,
          cursor: "pointer",
          color: "#555",
          fontWeight: 700,
          textAlign: "left",
        }}
        aria-expanded={!collapsed}
        aria-label={collapsed ? `Exibir ${titulo ?? ""}` : `Ocultar ${titulo ?? ""}`}
      >
        <span>{titulo}</span>
        <span
          aria-hidden="true"
          style={{
            fontSize: 18,
            lineHeight: 1,
            color: "#444",
          }}
        >
          {collapsed ? "+" : "-"}
        </span>
      </button>
      {!collapsed && <div style={{ marginTop: 10 }}>{children}</div>}
    </div>
  );
};
